(ns ui.totp.page
  "Totp Overview Page"
  (:require [storrito.ui.core :as ui]
            [storrito.ui.button :as button]
            [parts.replicant.query :as query]
            [storrito.ui.table :as ui-table]
            [storrito.util.link :as link]
            [ui.app-frame :as app-frame]
            [ui.totp.core :as core]))

(defn copy-to-clipboard [text]
  (-> (.-clipboard js/navigator)
      (.writeText text)
      (.then (fn []
               (js/console.log "Text copied to clipboard")))
      (.catch (fn [err]
                (js/console.error "Failed to copy text" err)))))

(defn table
  [state]
  (let [totp-data (sort-by :totp/name (vals (get-in (query/get-result state core/totp-query) [:totp :totp/entries])))
        progress (core/calc-expire-time state)]
    [:table
     {:class ui-table/table}
     [:thead {:class ui-table/thead}
      [:tr
       [:th
        {:scope "col"
         :class ui-table/th}
        "2FA Name"]
       [:th {:scope "col"
             :class ui-table/th}
        "OTP"]
       [:th {:scope "col"
             :class ui-table/th}
        "Additional Data"]
       [:th {:scope "col"
             :class ui-table/th}]]]
     [:tbody {:class ui-table/tbody}
      (if (seq totp-data)
        (map
          (fn [instance]
            [:tr {:class ui-table/tr}
             [:td {:class (concat ui-table/td
                                  ["font-medium"])}
              (:totp/name instance)]
             [:td
              {:class ui-table/td}
              [:div.flex
               [:div.flex.flex-col.items-center
                (:totp/otp instance)
                [:div.w-10.bg-gray-100.rounded-3xl.h-2.5.mt-2
                 [:div {:class "bg-indigo-600 h-2.5 rounded-3xl transition-all"
                        :style {:width (str (* 100 progress) "%")}}]]]
               [:button.ml-2
                {:style {:color "#D9DEE4"}
                 :on {:click (fn [e]
                               (copy-to-clipboard (:totp/otp instance)))}}
                [:i.fas.fa-copy]]]]
             [:td
              {:class ui-table/td}
              (:totp/description instance)]

             [:td {:class ui-table/td}
              [:div.flex.justify-end
               [:div
                {:style {:margin-block-end "0px"}}
                [:ui/a.link.mr-3
                 {:ui/location
                  {:location/page-id :pages/totp-new
                   :location/query-params {:uuid (:totp/uuid instance)}}}
                 [:i.fas.fa-edit]]

                (let [command {:command/kind :command/totp-delete
                               :command/data {:totp/uuid (:totp/uuid instance)}}
                      command-action [:data/command
                                      command
                                      {:on-success [[:data/query core/totp-query]]
                                       :on-error [[:ui/show-error]]}]]
                  [:ui/a.link
                   {:style {:cursor "pointer"}
                    :on {:click [[:js/confirm (str "Are you sure you wish to remove "
                                                   (:totp/name instance) "?")]
                                 command-action]}}
                   [:i.fas.fa-trash]])]]]])
          totp-data)
        [:tr {:class ui-table/tr}
         [:td {:colSpan 4
               :class (concat ui-table/td
                              ["font-medium"])}
          "Storrito has not been configured as an Authentication app for all your social accounts."]])]]))

(defn panel
  [state]
  [:div#panel
   [:div
    [:div
     {:class "sm:flex sm:items-center"}
     [:div
      {:class "sm:flex-auto"}
      [:h1 {:class ui/h2}
       "2FA Authenticator"]
      [:p.mt-2.text-gray-700
       "You can use Storrito as a two factor code generator for your Social Media Accounts."
       [:br] [:br]
       "Especially for Instagram this enables us to make the connection process much easier
       because there is no need anymore to share the two factor code with colleagues."
       "Also, Storrito can offer on-click reconnects and even automatic reconnects that way"
       [:a.ml-2
        {:href (link/help-center-url "2f6eae84-ce12-410c-8d50-aa1425ca0e2c")
         :target "_blank"}
        [:i.fas.fa-question-circle]]]]

     [:div
      {:class "mt-4 sm:ml-16 sm:mt-0"}
      [:ui/a.link
       {:ui/location
        {:location/page-id :pages/totp-new}
        :class ui/button-primary}
       "Setup"]]]

    [:div
     {:class "mt-8 flow-root"}
     [:div#table-and-form
      {:class "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"}
      [:div#table-container
       {:class
        "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"}
       [:div {:class ui/box}
        (table state)]]]]]])

(defn render [state]
  (app-frame/app-frame
    state
    (panel state)))

(def page
  {:page-id :pages/totp
   :route [["ui" "totp"]]
   :on-load (fn [_location]
              [[:data/query core/totp-query]
               [:totp/refresh]])
   :render #'render})


